import { useState } from 'react';
import {
  Box,
  CircularProgress,
  InputAdornment,
  Popover,
  TextField,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { Autocomplete } from '@mui/material';

export default function LocationMenuModal({
  id,
  open,
  anchorEl,
  handleClose,
  options,
  setLocation,
  isLoading,
  handleInputChange,
  inputRef,
  searchInput,
  setSearchInput,
}) {
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      fullWidth
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          mt: 2.5, // margin top offset
          ml: { sx: -4.3, lg: -4 }, // margin left offset
        },
      }}
      sx={{
        width: {
          xs: '390px', // Full width on extra small screens (mobile)
          sm: '400px', // 350px on small screens (tablet)
          md: '450px', // Original 450px on medium screens and up (desktop)
        },
        borderWidth: '1px',
        marginTop: '5px',
        borderRadius: '8px',
        borderColor: 'rgba(228, 233, 240, 1)',
        '.MuiAutocomplete-root .MuiAutocomplete-inputRoot .MuiAutocomplete-input':
          {
            maxWidth: '450px',
            width: '450px',
          },
        '.MuiPaper-root-MuiPopover-paper': {
          borderRadius: '8px',
          // boxShadow: 'none',
          boxShadow:
            '0px 0px 4px 0px rgba(0, 0, 0, 0.12), 0px 8px 12px 0px rgba(0, 0, 0, 0.08)',
          borderColor: '#000',
        },
        '.MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-root': {
          border: 'none',
          boxShadow: 'none',
        },
      }}
    >
      <Autocomplete
        size="small"
        fullWidth
        sx={{
          backgroundColor: 'rgba(249, 250, 252, 1)',
          borderRadius: '8px',
          margin: '5px',
          width: '98%',
          '.MuiOutlinedInput-root': {
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            height: '44px',
            width: '100%',
            padding: '0',
            boxShadow: 'none',
            '& fieldset': {
              border: 'none',
            },
          },
          '.MuiInputBase-input': {
            padding: '12px 14px',
            margin: 0,
            textAlign: 'left',
            height: '44px',
          },
          '.MuiFormControl-root-MuiTextField-root': {
            width: '100%',
          },
          '& .MuiOutlinedInput-root': {
            '.MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&: hover': {
              '.MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            },
          },
        }}
        autoFocus
        freeSolo
        ref={inputRef}
        options={options}
        getOptionLabel={(option) => option.description || option}
        filterOptions={(x) => x}
        loading={isLoading}
        inputValue={searchInput}
        onInputChange={(event, newInputValue) => {
          setSearchInput(newInputValue);
          handleInputChange(event, newInputValue);
        }}
        onChange={(event, newValue) => {
          if (newValue) {
            const selectedValue = newValue.description || newValue;
            setLocation(selectedValue);
            setSearchInput('');
          }
        }}
        onClose={handleClose}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            placeholder={'Search'}
            variant="outlined"
            sx={{
              fontSize: '14px',
              height: '44px',
              overflow: 'hidden',
              padding: '0',
              '.MuiOutlinedInput-input': {
                padding: '12px 14px',
              },
              '.MuiOutlinedInput-root': {
                border: '1px solid #ccc',
                boxShadow: 'none',
                '&:hover fieldset': {
                  border: '1px solid #aaa',
                },
                '&.Mui-focused fieldset': {
                  border: '1px solid #3f51b5',
                },
              },
            }}
            autoFocus
            fullWidth
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon cursor="pointer" sx={{ borderWidth: '1px' }} />
                </InputAdornment>
              ),
              endAdornment: (
                <>
                  {isLoading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Popover>
  );
}
